const ERROR_LOG_KEY = 'kouroshshield_error_log'
const MAX_LOG_SIZE = 50

function sanitizeError(error) {
  if (!error) return null
  const safe = {
    message: String(error.message || error),
    stack: error.stack || null,
    timestamp: new Date().toISOString(),
  }
  // Strip file paths that may contain system usernames
  if (safe.stack) {
    safe.stack = safe.stack
      .replace(/\\/g, '/')
      .replace(/\/Users\/[^/]+/g, '/Users/[user]')
      .replace(/\/home\/[^/]+/g, '/home/[user]')
  }
  return safe
}

function getLogs() {
  try {
    return JSON.parse(localStorage.getItem(ERROR_LOG_KEY) || '[]')
  } catch {
    return []
  }
}

function saveLogs(logs) {
  try {
    localStorage.setItem(ERROR_LOG_KEY, JSON.stringify(logs.slice(-MAX_LOG_SIZE)))
  } catch {
    // Storage full or unavailable
  }
}

export function logError(error, context = {}) {
  const entry = {
    ...sanitizeError(error),
    context: {
      type: context.type || 'unknown',
      route: window.location.pathname,
      component: context.component || null,
      ...(context.extra || {}),
    },
  }

  const logs = getLogs()
  logs.push(entry)
  saveLogs(logs)

  // Dev-only console output
  if (import.meta.env.DEV) {
    console.groupCollapsed(
      `%c[ErrorLogger] ${entry.context.type}: ${entry.message}`,
      'color: #ef4444; font-weight: bold'
    )
    console.error(error)
    if (context.component) console.log('Component:', context.component)
    if (entry.stack) console.log('Stack:', entry.stack)
    console.groupEnd()
  }

  return entry
}

export function getErrorLogs() {
  return getLogs()
}

export function clearErrorLogs() {
  localStorage.removeItem(ERROR_LOG_KEY)
}

export function initGlobalErrorHandlers() {
  // Catch unhandled errors
  window.addEventListener('error', (event) => {
    logError(event.error || new Error(event.message), {
      type: 'unhandled_error',
      extra: { filename: event.filename, lineno: event.lineno, colno: event.colno },
    })
  })

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    logError(reason instanceof Error ? reason : new Error(String(reason)), {
      type: 'unhandled_rejection',
    })
  })
}
